import * as MediaAssetAPI from '@/api/media-asset';
import { useCurrentApp } from '@/stores/userDataStore';
import { useMediaAssetGeneration } from '@/hooks/useMediaAssetGeneration';
import { MediaAssetImageProvider, PlacementType } from '@/types/media';

interface ImageBackgroundGenerationProps {
  productId?: string;
  productTitle?: string;
  imageSrc: string;
  prompt: string;
  aspectRatio?: '9:16' | '16:9' | '1:1';
  backgroundImageSrc?: string;
  placementType?: PlacementType;
}

export const useImageBackgroundGeneration = () => {
  const { appKey, appUrl } = useCurrentApp();

  return useMediaAssetGeneration({
    mutationFn: async ({
      imageSrc,
      productId,
      productTitle,
      prompt,
      aspectRatio = '16:9',
      backgroundImageSrc,
      placementType = PlacementType.ManualPlacement,
    }: ImageBackgroundGenerationProps) => {
      if (!imageSrc) return null;
      if (!prompt && !backgroundImageSrc) {
        throw new Error('Either prompt or backgroundImageSrc must be provided');
      }

      const response = await MediaAssetAPI.replaceBackground({
        appKey,
        appUrl,
        image: imageSrc,
        backgroundPrompt: prompt || '',
        productId,
        productTitle,
        autogenerated: false,
        aspectRatio,
        placementType,
        backgroundReferenceImage: backgroundImageSrc,
        provider: MediaAssetImageProvider.BRIA,
      });

      return response.mediaAssets;
    },
  });
};
